import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MapPinIcon, BuildingOffice2Icon, ArrowRightIcon } from "@heroicons/react/24/outline";
import Hero from "../components/Hero";
import destImg from "../assests/images/hotel-bg.jpg";

export default function DestinationsList({
    showBanner = true,
    showHeading = true
}) {
    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    // Fetch destinations
    const fetchDestinations = async () => {
        setLoading(true);

        try {
            const res = await axios.get(
                "https://cheapdubaihotels.com/api/destinations"
            );

            setDestinations(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDestinations();
    }, []);

    return (
        <div className="w-full bg-white">

            {/* =========================
                BANNER
            ========================== */}
            {showBanner && window.location.pathname !== "/" && (
                <Hero
                    variant="inner"
                    title="All Destinations"
                    subtitle="Explore the best places to stay and discover Dubai your way"
                    backgroundImage={destImg}
                />
            )}

            {/* =========================
                DESTINATIONS SECTION
            ========================== */}
            <section className="py-12 sm:py-14 lg:py-16">
                <div className=" max-w-[1536px] mx-auto
              px-4
            sm:px-6
            lg:px-8 mx-auto px-4 sm:px-6 lg:px-8">

                    {/* =========================
                        HEADING
                    ========================== */}
                    {showHeading && (
                        <div className="mb-9 sm:mb-10">

                            <div className="flex items-center gap-2 mb-3">
                                <span className="h-[2px] w-8 bg-[#F7B928]"></span>

                                <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.16em] text-[#0B6E8E]">
                                    Explore Dubai
                                </span>
                            </div>

                            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">

                                <div>
                                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-[#062F4F]">
                                        All Destinations
                                    </h2>

                                    <p className="mt-2.5 max-w-2xl text-sm sm:text-base leading-7 text-slate-600">
                                        Discover the best areas and destinations for
                                        your next Dubai stay.
                                    </p>
                                </div>

                                <div className="hidden sm:flex items-center gap-2 text-sm font-semibold text-[#0B6E8E]">
                                    <MapPinIcon className="h-5 w-5" />
                                    <span>Dubai & Beyond</span>
                                </div>

                            </div>
                        </div>
                    )}

                    {/* =========================
                        LOADING
                    ========================== */}
                    {loading ? (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 sm:gap-6">

                            {[1, 2, 3, 4].map((item) => (
                                <div
                                    key={item}
                                    className="overflow-hidden rounded-2xl border border-[#DFE8ED] bg-white"
                                >
                                    <div className="h-60 bg-slate-200 animate-pulse"></div>

                                    <div className="p-5">
                                        <div className="h-5 w-2/3 rounded bg-slate-200 animate-pulse"></div>

                                        <div className="mt-3 h-4 w-1/2 rounded bg-slate-200 animate-pulse"></div>

                                        <div className="mt-5 h-10 rounded-lg bg-slate-200 animate-pulse"></div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    ) : (
                        <>
                            {destinations.length > 0 ? (
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 sm:gap-6">

                                    {destinations.map((dest) => (
                                        <div
                                            key={dest.id}
                                            onClick={() =>
                                                navigate(
                                                    `/destinations/${dest.slug}`
                                                )
                                            }
                                            className="
                                                group
                                                relative
                                                overflow-hidden
                                                rounded-2xl
                                                border
                                                border-[#DFE8ED]
                                                bg-white
                                                cursor-pointer
                                                shadow-[0_5px_20px_rgba(6,47,79,0.07)]
                                                hover:-translate-y-1
                                                hover:border-[#0B6E8E]/30
                                                hover:shadow-[0_15px_35px_rgba(6,47,79,0.14)]
                                                transition-all
                                                duration-300
                                            "
                                        >

                                            {/* =========================
                                                IMAGE
                                            ========================== */}
                                            <div className="relative h-60 overflow-hidden">

                                                <img
                                                    src={`https://uaediscountedhotels.com/uploads/destinations/${dest.image}`}
                                                    alt={dest.name}
                                                    className="
                                                        w-full
                                                        h-full
                                                        object-cover
                                                        group-hover:scale-105
                                                        transition-transform
                                                        duration-700
                                                    "
                                                />

                                                {/* Image overlay */}
                                                <div className="absolute inset-0 bg-gradient-to-t from-[#062F4F]/85 via-[#062F4F]/20 to-transparent"></div>

                                                {/* Destination badge */}
                                                <div className="absolute top-4 left-4">
                                                    <div className="
                                                        inline-flex
                                                        items-center
                                                        gap-1.5
                                                        rounded-full
                                                        bg-white/95
                                                        px-3
                                                        py-1.5
                                                        text-xs
                                                        font-bold
                                                        text-[#062F4F]
                                                        shadow-sm
                                                    ">
                                                        <MapPinIcon className="h-3.5 w-3.5 text-[#0B6E8E]" />
                                                        Destination
                                                    </div>
                                                </div>

                                                {/* Arrow */}
                                                <div className="
                                                    absolute
                                                    top-4
                                                    right-4
                                                    flex
                                                    h-9
                                                    w-9
                                                    items-center
                                                    justify-center
                                                    rounded-full
                                                    bg-white/95
                                                    text-[#062F4F]
                                                    opacity-0
                                                    translate-x-2
                                                    group-hover:opacity-100
                                                    group-hover:translate-x-0
                                                    transition-all
                                                    duration-300
                                                    shadow-sm
                                                ">
                                                    <ArrowRightIcon className="h-4 w-4" />
                                                </div>

                                                {/* Image content */}
                                                <div className="absolute bottom-0 left-0 right-0 p-5">

                                                    <h3 className="
                                                        text-xl
                                                        font-extrabold
                                                        leading-tight
                                                        text-white
                                                        drop-shadow-sm
                                                    ">
                                                        {dest.name}
                                                    </h3>

                                                    <div className="mt-2 flex items-center gap-2">

                                                        <BuildingOffice2Icon className="h-4 w-4 text-[#F7B928]" />

                                                        <span className="text-sm font-semibold text-white/90">
                                                            {dest.hotels_count} Hotels
                                                        </span>

                                                    </div>

                                                </div>
                                            </div>

                                            {/* =========================
                                                CARD CONTENT
                                            ========================== */}
                                            <div className="p-5">

                                                <div className="flex items-center justify-between gap-3">

                                                    <div>
                                                        <p className="text-xs font-bold uppercase tracking-wider text-[#0B6E8E]">
                                                            Stay & Explore
                                                        </p>

                                                        <p className="mt-1 text-sm leading-5 text-slate-500">
                                                            Find hotels in this destination
                                                        </p>
                                                    </div>

                                                    <div className="
                                                        flex
                                                        h-10
                                                        w-10
                                                        shrink-0
                                                        items-center
                                                        justify-center
                                                        rounded-full
                                                        bg-[#EAF6F8]
                                                        text-[#0B6E8E]
                                                        group-hover:bg-[#0B6E8E]
                                                        group-hover:text-white
                                                        transition-colors
                                                        duration-300
                                                    ">
                                                        <ArrowRightIcon className="h-4 w-4" />
                                                    </div>

                                                </div>

                                                <div className="mt-5 pt-4 border-t border-[#E8EEF1]">

                                                    <div className="flex items-center justify-between">

                                                        <span className="text-xs font-semibold text-slate-500">
                                                            Explore hotels
                                                        </span>

                                                        <span className="
                                                            text-xs
                                                            font-bold
                                                            text-[#062F4F]
                                                            group-hover:text-[#FF5A1F]
                                                            transition-colors
                                                        ">
                                                            View Destination
                                                        </span>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                    ))}

                                </div>
                            ) : (
                                /* =========================
                                    EMPTY STATE
                                ========================== */
                                <div className="
                                    rounded-2xl
                                    border
                                    border-[#DFE8ED]
                                    bg-[#F7FAFC]
                                    px-6
                                    py-16
                                    text-center
                                ">

                                    <div className="
                                        mx-auto
                                        flex
                                        h-14
                                        w-14
                                        items-center
                                        justify-center
                                        rounded-full
                                        bg-[#EAF6F8]
                                        text-[#0B6E8E]
                                    ">
                                        <MapPinIcon className="h-7 w-7" />
                                    </div>

                                    <h3 className="mt-5 text-xl font-bold text-[#062F4F]">
                                        No destinations found
                                    </h3>

                                    <p className="mt-2 text-sm text-slate-500">
                                        Please check back again soon for available destinations.
                                    </p>

                                </div>
                            )}
                        </>
                    )}

                </div>
            </section>
        </div>
    );
}